<template>
  <div class="register-container">

<transition name="fade">
  
    <main id="main-content" aria-label="Zone principale de la page d'inscription">
  <form
      @submit.prevent="register"
      class="register-form"
      name="register"
      method="POST" aria-label="Formulaire d'inscription"
aria-describedby="register-form-info"
 role="form"
  data-netlify="true"

    >
      <!-- Champ Prénom -->
      <div class="form-group">
        <label for="first-name">
          <i class="fas fa-user my-icon"></i> {{ translated.firstName }}
        </label>
        <input
          id="first-name"
          class="form-control"
          v-model="first_name"
          type="text"
          required
          :placeholder="translated.enterFirstName"
          aria-label="Prénom"
          :aria-invalid="!first_name"
  aria-required="true"


        />
      </div>

      <!-- Champ Nom -->
      <div class="form-group">
        <label for="last-name">
          <i class="fas fa-user-tag my-icon"></i> {{ translated.lastName }}
        </label>
        <input
          id="last-name"
          class="form-control"
          v-model="last_name"
          type="text"
          required
          :placeholder="translated.enterLastName"
          aria-label="Nom" :aria-invalid="!last_name"
  aria-required="true"
        />
      </div>

      <!-- Champ Nom d'utilisateur -->
      <div class="form-group">
        <label for="username">
          <i class="fas fa-user-circle my-icon"></i> {{ translated.username }}
        </label>
        <input
          id="username"
          class="form-control"
          v-model="username"
          type="text"
          required
          :placeholder="translated.enterUsername"
          aria-label="Nom d'utilisateur"
          :aria-invalid="!username"
  aria-required="true"
        />
      </div>

      <!-- Champ Email -->
      <div class="form-group">
        <label for="email">
          <i class="fas fa-envelope my-icon"></i> {{ translated.email }}
        </label>
        <input
          id="email"
          class="form-control"
          v-model="email"
          type="email"
          required
          :placeholder="translated.enterEmail"
          aria-label="Email" :aria-invalid="!email"
  aria-required="true"
        />
      </div>

      <!-- Champ Mot de passe -->
      <div class="form-group">
        <label for="password">
          <i class="fas fa-lock my-icon"></i> {{ translated.password }}
        </label>
        <div class="password-wrapper">
          <input
            id="password"
            class="form-control"
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            required
            :placeholder="translated.enterPassword"
            aria-label="Mot de passe" :aria-invalid="!password"
  aria-required="true"
          />
          <button
            type="button"
            class="toggle-password"
            @click="togglePassword"
            aria-label="Afficher ou masquer le mot de passe"
          >
            <i
  :class="['my-icon', showPassword ? 'fas fa-eye-slash' : 'fas fa-eye']"
></i>

          </button>
        </div>
      </div>

      <!-- Champ Confirmation du mot de passe -->
      <div class="form-group">
        <label for="confirm-password">
          <i class="fas fa-check-circle my-icon"></i>
          {{ translated.confirmPassword }}
        </label>
        <input
          id="confirm-password"
          
          class="form-control"
          v-model="confirmPassword"
          :type="showPassword ? 'text' : 'password'"
          required
          :placeholder="translated.confirmYourPassword"
          aria-label="Confirmer le mot de passe" aria-required="true"
:aria-invalid="!confirmPassword"
autocomplete="new-password"


        />
      </div>

      <!-- Bouton d'inscription -->
      <div class="form-group">
        <button
  type="submit"
  class="btn btn-primary btn-lg w-100"
  :disabled="isLoading"
  aria-label="Valider votre inscription"
>

          {{ isLoading ? translated.loading : translated.register }}
        </button>
      </div>
<div class="sr-only" aria-live="assertive">
  <!-- Pour affichage dynamique d'erreur ou confirmation -->
</div>

      <!-- Affichage des erreurs -->
      <div v-if="error" class="error" role="alert">{{ error }}</div>

      <!-- Lien vers la connexion -->
      <div class="form-links">
        <NuxtLink to="/login">🔑 {{ translated.alreadyHaveAccount }}</NuxtLink>
      </div>
    </form>



    </main>

</transition>
  
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useNuxtApp } from "#imports";
import * as Toastification from "vue-toastification";

const toast = Toastification.useToast();
const { $translate } = useNuxtApp();
const router = useRouter();

const first_name = ref("");
const last_name = ref("");
const username = ref("");
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const showPassword = ref(false);
const error = ref("");
const isLoading = ref(false);
const translatedTitle = ref("")
const translatedDescription = ref("")



const translated = ref({
  firstName: "Prénom",
  lastName: "Nom",
  username: "Nom d'utilisateur",
  email: "Email",
  password: "Mot de passe",
  confirmPassword: "Confirmer le mot de passe",
  enterFirstName: "Entrez votre prénom",
  enterLastName: "Entrez votre nom",
  enterUsername: "Choisissez un nom d'utilisateur",
  enterEmail: "Entrez votre email",
  enterPassword: "Entrez votre mot de passe",
  confirmYourPassword: "Confirmez votre mot de passe",
  register: "🚀 S'inscrire",
  alreadyHaveAccount: "Déjà un compte ? Connexion",
  loading: "⏳ Inscription en cours...",
});
function validateInputs() {
  if (!first_name.value.trim()) {
    error.value = "Veuillez saisir votre prénom.";
    return false;
  }
  if (!last_name.value.trim()) {
    error.value = "Veuillez saisir votre nom.";
    return false;
  }
  if (!username.value.trim()) {
    error.value = "Veuillez choisir un nom d'utilisateur.";
    return false;
  }
  if (!email.value.trim()) {
    error.value = "Veuillez saisir votre adresse email.";
    return false;
  }
  if (!password.value) {
    error.value = "Veuillez saisir un mot de passe.";
    return false;
  }
  if (password.value.length < 8) {
    error.value = "Le mot de passe doit contenir au moins 8 caractères.";
    return false;
  }
  if (password.value !== confirmPassword.value) {
    error.value = "Les mots de passe ne correspondent pas.";
    return false;
  }
  return true;
}

// ✅ Traduction dynamique
onMounted(async () => {
    translatedTitle.value = await $translate("🚀 Créez un compte")
  translatedDescription.value = await $translate("Inscrivez-vous pour profiter de tous les contenus exclusifs de Longoka.")
  translated.value.firstName = await $translate("Prénom");
  translated.value.lastName = await $translate("Nom");
  translated.value.username = await $translate("Nom d'utilisateur");
  translated.value.email = await $translate("Email");
  translated.value.password = await $translate("Mot de passe");
  translated.value.confirmPassword = await $translate(
    "Confirmer le mot de passe"
  );
  translated.value.enterFirstName = await $translate("Entrez votre prénom");
  translated.value.enterLastName = await $translate("Entrez votre nom");
  translated.value.enterUsername = await $translate(
    "Choisissez un nom d'utilisateur"
  );
  translated.value.enterEmail = await $translate("Entrez votre email");
  translated.value.enterPassword = await $translate(
    "Entrez votre mot de passe"
  );
  translated.value.confirmYourPassword = await $translate(
    "Confirmez votre mot de passe"
  );
  translated.value.register = await $translate("🚀 S'inscrire");
  translated.value.alreadyHaveAccount = await $translate(
    "Déjà un compte ? Connexion"
  );
  translated.value.loading = await $translate("⏳ Inscription en cours...");
});

// ✅ Vérification et soumission du formulaire
const register = async () => {
  error.value = "";
  if (!validateInputs()) return;

  isLoading.value = true;

  try {
    const response = await fetch("/api/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        first_name: first_name.value.trim(),
        last_name: last_name.value.trim(),
        username: username.value.trim(),
        email: email.value.trim().toLowerCase(),
        password: password.value,
      }),
    });

    const result = await response.json();

    if (response.ok) {
      toast.success("✅ Inscription réussie ! Vérifiez votre email.");
      router.push("/register/success");
    } else {
      error.value = result.error || "❌ Erreur lors de l'inscription.";
    }
  } catch (e) {
    error.value = "❌ Une erreur est survenue. Veuillez réessayer.";
  } finally {
    isLoading.value = false;
  }
};

const togglePassword = () => {
  showPassword.value = !showPassword.value;
};
</script>

<style scoped>
.register-container {
  max-width: 700px; /* était 500px */
  margin: 40px auto;
  padding: 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.register-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #333;
}



input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
}

.password-wrapper {
  display: flex;
  align-items: center;
}

.toggle-password {
  background: none;
  border: none;
  cursor: pointer;
  color: #ff4500;
  font-size: 1.2rem;
  padding-left: 10px;
}

.error {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}
/* css des boutons */
/*
.btn-primary {
  background-color: #007bff; 
  color: white;
  font-size: 1rem;
  padding: 12px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.btn-primary:hover {
  background-color: #0069d9;
  box-shadow: 0 4px 10px rgba(0, 123, 255, 0.3);
  transform: scale(1.05); 
}
*/

.btn-primary:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  transform: none;
}



/* Fin css des boutons*/
.form-links {
  text-align: center;
  margin-top: 15px;
}

.form-links a {
  color: #ff4500;
  text-decoration: none;
}

.form-links a:hover {
  text-decoration: underline;
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.fade-enter-active {
  animation: fadeIn 0.6s ease;
}

/* ✅ Responsivité */
@media (max-width: 768px) {
  .register-container {
    padding: 20px;
  }

  .btn-primary {
    font-size: 1rem;
    padding: 12px;
  }

  input {
    font-size: 0.9rem;
    padding: 10px;
  }
    .my-icon {
    font-size: 1rem;
  }
}

</style>
